exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._13t2HFsEDEAb0-c2dOkDUQ {\n  flex: 1;\n}\n\n._1ZAIezZlSuAaEbbi5BU5Cj {\n  max-width: 100%;\n  padding: 0.25rem 0;\n}\n\n._3gIKjZ1RWh53lnv3PVx58d {\n  opacity: .5;\n}\n\n._3g76TRzdJbe9BUWHdw73nZ,\n._3E0t6sB4rHJgQ9mP7qS3js {\n  font-size: 1em;\n}\n\n.CodeMirror {\n  height: auto;\n  font-size: 0.75rem;\n}\n", ""]);
// Exports
exports.locals = {
	"Wrapper": "_13t2HFsEDEAb0-c2dOkDUQ",
	"Option": "_1ZAIezZlSuAaEbbi5BU5Cj",
	"OptionDisabled": "_3gIKjZ1RWh53lnv3PVx58d",
	"Label": "_3g76TRzdJbe9BUWHdw73nZ",
	"Input": "_3E0t6sB4rHJgQ9mP7qS3js"
};